"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCoachMarkBehavior = void 0;
var default_behavior_1 = require("./../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_coach_mark_constants_1 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_2 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_3 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_4 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_5 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_6 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_7 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_8 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_9 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_10 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_11 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_12 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_13 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_14 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_15 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_16 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_17 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_18 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_19 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_20 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_21 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_22 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_23 = require("./bc-coach-mark-constants");
var bc_coach_mark_constants_24 = require("./bc-coach-mark-constants");
var helpers_1 = require("../../../common/helpers");
var bc_location_builder_client_rect_utils_1 = require("../../../common/location-builder/location-builder-client-rect/bc-location-builder-client-rect-utils");
var bc_location_builder_1 = require("../../../common/location-builder/bc-location-builder");
var bc_location_builder_position_1 = require("../../../common/location-builder/bc-location-builder-position");
var BcCoachMarkBehavior = (function (_super) {
    __extends(BcCoachMarkBehavior, _super);
    function BcCoachMarkBehavior() {
        return _super.call(this) || this;
    }
    BcCoachMarkBehavior.setUpAll = function () {
        var coachMarkGroup = Array.from(document.querySelectorAll(".".concat(bc_coach_mark_constants_7.BC_COACH_MARK_SELECTOR)));
        var elements = [];
        for (var _i = 0, coachMarkGroup_1 = coachMarkGroup; _i < coachMarkGroup_1.length; _i++) {
            var element = coachMarkGroup_1[_i];
            var bcCoachMarkBehavior = new BcCoachMarkBehavior();
            bcCoachMarkBehavior.setElement(element);
            bcCoachMarkBehavior.setUp();
            elements.push(bcCoachMarkBehavior);
        }
        return elements;
    };
    BcCoachMarkBehavior.prototype._setUp = function () {
        this.hashMap = new Map();
        this.coachMarkElement = this.mySelf.querySelector(".".concat(bc_coach_mark_constants_21.BC_COACH_MARK_CONTAINER));
        this.pagination = this.mySelf.querySelector("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, ".").concat(bc_coach_mark_constants_15.BC_COACH_MARK_QUANTITY_ITEMS));
        this.sliderElements = Array.from(this.mySelf.querySelectorAll(".".concat(bc_coach_mark_constants_1.BC_COACH_MARK_MAIN)));
        this.buttonPrev = this.mySelf.querySelector(".".concat(bc_coach_mark_constants_13.BC_COACH_MARK_PREV));
        this.buttonNext = this.mySelf.querySelector(".".concat(bc_coach_mark_constants_12.BC_COACH_MARK_NEXT));
        this.buttonUnderstand = this.mySelf.querySelector(".".concat(bc_coach_mark_constants_6.BC_COACH_MARK_FOOTER_FIRST_BUTTON));
        this.arrowElement = (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.DIV_TAG, classList: [bc_coach_mark_constants_24.BC_COACH_MARK_ARROW_CLASS] });
        this.createPaginationStep();
        this.setAccessibility();
        this.addEventListeners();
    };
    BcCoachMarkBehavior.prototype.createPaginationStep = function () {
        var bodysContent = Array.from(this.mySelf.querySelectorAll(".".concat(bc_coach_mark_constants_1.BC_COACH_MARK_MAIN)));
        this.pagination.innerHTML = '';
        var initialNumber = "".concat(bc_coach_mark_constants_18.BC_COACH_MARK_NUMBER_1, "/").concat(bodysContent.length);
        this.pagination.appendChild((0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_coach_mark_constants_16.BC_COACH_MARK_NUMBER],
            innerText: initialNumber,
        }));
    };
    BcCoachMarkBehavior.prototype.setStepQuantity = function () {
        var currentStep = this.currentStep();
        var paginationNumber = this.mySelf.querySelector(".".concat(bc_coach_mark_constants_16.BC_COACH_MARK_NUMBER));
        if (paginationNumber) {
            paginationNumber.innerHTML = '';
            paginationNumber.innerHTML = "".concat(currentStep + bc_coach_mark_constants_18.BC_COACH_MARK_NUMBER_1, "/").concat(this.sliderElements.length);
            paginationNumber.setAttribute(bc_coach_mark_constants_3.BC_COACH_MARK_ARIA_LABEL, 'Paso ' + "".concat(currentStep + bc_coach_mark_constants_18.BC_COACH_MARK_NUMBER_1) + ' de ' + "".concat(this.sliderElements.length));
        }
    };
    BcCoachMarkBehavior.prototype.setButtonsStyle = function () {
        var currentStep = this.currentStep();
        if (this.sliderElements.length == 1) {
            this.setNextAndUnderstoodButton();
            this.pagination.remove();
            (0, helpers_1.replaceClass)(this.buttonPrev, bc_coach_mark_constants_5.bcDisplay.flex, bc_coach_mark_constants_5.bcDisplay.none);
        }
        else {
            if (currentStep + bc_coach_mark_constants_18.BC_COACH_MARK_NUMBER_1 == 1) {
                (0, helpers_1.replaceClass)(this.buttonUnderstand, bc_coach_mark_constants_14.BC_COACH_MARK_CLOSE, bc_coach_mark_constants_12.BC_COACH_MARK_NEXT);
                (0, helpers_1.replaceClass)(this.buttonPrev, bc_coach_mark_constants_5.bcDisplay.flex, bc_coach_mark_constants_5.bcDisplay.none);
                this.buttonUnderstand.setAttribute(bc_coach_mark_constants_3.BC_COACH_MARK_ARIA_LABEL, bc_coach_mark_constants_23.BC_COACH_MARK_NEXT_TEXT);
            }
            else if (currentStep + bc_coach_mark_constants_18.BC_COACH_MARK_NUMBER_1 == this.sliderElements.length) {
                this.buttonUnderstand.textContent = bc_coach_mark_constants_19.BC_COACH_MARK_UNDERSTOOD_TEXT;
                this.setNextAndUnderstoodButton();
                (0, helpers_1.replaceClass)(this.buttonPrev, bc_coach_mark_constants_5.bcDisplay.none, bc_coach_mark_constants_5.bcDisplay.flex);
                this.buttonPrev.setAttribute(bc_coach_mark_constants_3.BC_COACH_MARK_ARIA_LABEL, bc_coach_mark_constants_3.BC_COACH_MARK_PREV_TEXT);
            }
            else {
                (0, helpers_1.replaceClass)(this.buttonPrev, bc_coach_mark_constants_5.bcDisplay.none, bc_coach_mark_constants_5.bcDisplay.flex);
                (0, helpers_1.replaceClass)(this.buttonUnderstand, bc_coach_mark_constants_5.bcDisplay.none, bc_coach_mark_constants_5.bcDisplay.flex);
                (0, helpers_1.replaceClass)(this.buttonUnderstand, bc_coach_mark_constants_14.BC_COACH_MARK_CLOSE, bc_coach_mark_constants_12.BC_COACH_MARK_NEXT);
                if (this.buttonUnderstand && this.buttonPrev) {
                    this.buttonPrev.setAttribute(bc_coach_mark_constants_3.BC_COACH_MARK_ARIA_LABEL, bc_coach_mark_constants_3.BC_COACH_MARK_PREV_TEXT);
                    this.buttonUnderstand.setAttribute(bc_coach_mark_constants_3.BC_COACH_MARK_ARIA_LABEL, bc_coach_mark_constants_23.BC_COACH_MARK_NEXT_TEXT);
                }
            }
        }
    };
    BcCoachMarkBehavior.prototype.setNextAndUnderstoodButton = function () {
        if (this.buttonUnderstand) {
            this.buttonUnderstand.textContent = bc_coach_mark_constants_19.BC_COACH_MARK_UNDERSTOOD_TEXT;
            this.buttonUnderstand.setAttribute(bc_coach_mark_constants_3.BC_COACH_MARK_ARIA_LABEL, bc_coach_mark_constants_19.BC_COACH_MARK_UNDERSTOOD_TEXT);
            (0, helpers_1.replaceClass)(this.buttonUnderstand, bc_coach_mark_constants_12.BC_COACH_MARK_NEXT, bc_coach_mark_constants_14.BC_COACH_MARK_CLOSE);
        }
    };
    BcCoachMarkBehavior.prototype.initTour = function () {
        for (var _i = 0, _a = this.sliderElements; _i < _a.length; _i++) {
            var slider = _a[_i];
            this.targetElement = document.getElementById(slider.getAttribute(bc_coach_mark_constants_20.BC_COACH_MARK_DATA_CONTROLLER));
            this.setValueTour(this.targetElement, slider);
            this.setStepQuantity();
            break;
        }
        if (this.sliderElements.length == 1) {
            this.buttonPrev.innerText = bc_coach_mark_constants_19.BC_COACH_MARK_UNDERSTOOD_TEXT;
        }
    };
    BcCoachMarkBehavior.prototype.setValueTour = function (element, slider) {
        this.removeAllProperties();
        this.createOverlay();
        element.classList.add("".concat(bc_coach_mark_constants_10.BC_COACH_MARK_HIGHLIGHT));
        var optionScrollView = {
            block: 'nearest',
            inline: 'nearest'
        };
        element.scrollIntoView(optionScrollView);
        this.setTargetBackground(element);
        slider.setAttribute(bc_coach_mark_constants_8.BC_COACH_MARK_STATUS, bc_coach_mark_constants_9.BC_COACH_MARK_STATUS_ACTIVE);
        element.appendChild(this.arrowElement);
        document.body.append(this.mySelf);
        this.setPosition(this.coachMarkElement, this.arrowElement, element);
        this.coachMarkElement.classList.add("".concat(bc_coach_mark_constants_7.BC_COACH_MARK_SELECTOR, "-expanded"));
        if (element.classList.contains("".concat(bc_coach_mark_constants_8.BC_COACH_MARK_TARGET))) {
            this.focusElement();
        }
        else {
            this.setInitTargetZIndex(element);
        }
        document.body.style.overflow = 'hidden';
        element['style'].pointerEvents = 'none';
        this.setButtonsStyle();
    };
    BcCoachMarkBehavior.prototype.removeHighLight = function () {
        var isHighLight = this.sliderElements.find(function (coachMarkContent) { return coachMarkContent.getAttribute(bc_coach_mark_constants_8.BC_COACH_MARK_STATUS); });
        if (isHighLight) {
            var elementCurrent = document.getElementById(isHighLight.getAttribute(bc_coach_mark_constants_20.BC_COACH_MARK_DATA_CONTROLLER));
            elementCurrent.classList.remove(bc_coach_mark_constants_10.BC_COACH_MARK_HIGHLIGHT);
            elementCurrent['style'].pointerEvents = 'all';
            isHighLight.removeAttribute(bc_coach_mark_constants_8.BC_COACH_MARK_STATUS);
        }
    };
    BcCoachMarkBehavior.prototype.createOverlay = function () {
        var status = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_coach_mark_constants_11.BC_COACH_MARK_OVERLAY],
        });
        document.body.insertBefore(status, null);
        this.addClassBlockScroll();
    };
    BcCoachMarkBehavior.prototype.addClassBlockScroll = function () {
        var bodySelector = document.body;
        bodySelector.classList.add(bc_coach_mark_constants_22.BC_COACH_MARK_BLOCK_SCROLL);
    };
    BcCoachMarkBehavior.prototype.removeOverlay = function () {
        var overlayElement = document.querySelector(".".concat(bc_coach_mark_constants_11.BC_COACH_MARK_OVERLAY));
        if (overlayElement) {
            overlayElement.remove();
        }
        this.removeClassBlockScroll();
    };
    BcCoachMarkBehavior.prototype.removeClassBlockScroll = function () {
        var bodySelector = document.body;
        bodySelector.classList.remove(bc_coach_mark_constants_22.BC_COACH_MARK_BLOCK_SCROLL);
    };
    BcCoachMarkBehavior.prototype.removeAllProperties = function () {
        this.removeOverlay();
        this.removeHighLight();
    };
    BcCoachMarkBehavior.prototype.focusElement = function () {
        var focusCoachMark = this.mySelf.querySelector(".".concat(bc_coach_mark_constants_21.BC_COACH_MARK_CONTAINER));
        focusCoachMark.scrollIntoView();
    };
    BcCoachMarkBehavior.prototype.addEventListeners = function () {
        this.listenerNext();
        this.listenerPrev();
        this.listenerCloseButton();
    };
    BcCoachMarkBehavior.prototype.listenerCloseButton = function () {
        var _this = this;
        this.mySelf.querySelectorAll(".".concat(bc_coach_mark_constants_14.BC_COACH_MARK_CLOSE)).forEach(function (item) {
            item.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
                _this.hideWindow();
            });
        });
    };
    BcCoachMarkBehavior.prototype.listenerNext = function () {
        var _this = this;
        this.buttonUnderstand.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            if (_this.buttonUnderstand.innerText !== bc_coach_mark_constants_19.BC_COACH_MARK_UNDERSTOOD_TEXT) {
                _this.nextStep();
            }
            else {
                _this.hideWindow();
            }
        });
    };
    BcCoachMarkBehavior.prototype.hideWindow = function () {
        this.coachMarkElement.classList.remove("".concat(bc_coach_mark_constants_7.BC_COACH_MARK_SELECTOR, "-expanded"));
        this.coachMarkElement.style.animation = bc_coach_mark_constants_4.BC_COACH_MARK_ANIMATION_OUT;
        this.setTargetZIndexClose();
        this.restoreValueButton();
        this.removeAllProperties();
        this.arrowElement.remove();
        this.mySelf.remove();
        document.body.style.overflow = 'visible';
    };
    BcCoachMarkBehavior.prototype.listenerPrev = function () {
        var _this = this;
        var buttonPrev = this.mySelf.querySelector(".".concat(bc_coach_mark_constants_13.BC_COACH_MARK_PREV));
        buttonPrev.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            var stepActive = _this.currentStep();
            if (stepActive > 0) {
                _this.prevStep();
            }
            else {
                _this.hideWindow();
            }
        });
    };
    BcCoachMarkBehavior.prototype.nextStep = function () {
        this.arrowElement.remove();
        this.moveStep(bc_coach_mark_constants_18.BC_COACH_MARK_NUMBER_1);
    };
    BcCoachMarkBehavior.prototype.prevStep = function () {
        this.arrowElement.remove();
        this.moveStep();
    };
    BcCoachMarkBehavior.prototype.currentStep = function () {
        var currentElement = this.sliderElements.find(function (item) { return item.getAttribute(bc_coach_mark_constants_8.BC_COACH_MARK_STATUS) === bc_coach_mark_constants_9.BC_COACH_MARK_STATUS_ACTIVE; });
        return parseInt(currentElement.getAttribute(bc_coach_mark_constants_17.BC_COACH_MARK_DATA_ATTRIBUTE));
    };
    BcCoachMarkBehavior.prototype.moveStep = function (step) {
        if (step === void 0) { step = 0; }
        var stepActive;
        var button = this.mySelf.querySelector(".".concat(bc_coach_mark_constants_6.BC_COACH_MARK_FOOTER_FIRST_BUTTON));
        var currentActive = this.sliderElements.find(function (coachMarkContent) { return coachMarkContent.getAttribute(bc_coach_mark_constants_8.BC_COACH_MARK_STATUS); });
        if (currentActive) {
            var valueItemData = parseInt(currentActive.getAttribute(bc_coach_mark_constants_17.BC_COACH_MARK_DATA_ATTRIBUTE));
            if (step) {
                stepActive = valueItemData + bc_coach_mark_constants_18.BC_COACH_MARK_NUMBER_1;
            }
            else {
                stepActive = valueItemData - bc_coach_mark_constants_18.BC_COACH_MARK_NUMBER_1;
            }
            if (stepActive === this.sliderElements.length - bc_coach_mark_constants_18.BC_COACH_MARK_NUMBER_1) {
                button.innerText = "".concat(bc_coach_mark_constants_19.BC_COACH_MARK_UNDERSTOOD_TEXT);
            }
            else {
                this.restoreValueButton();
            }
            var setStepNext = this.sliderElements.find(function (coachMarkContent) { return parseInt(coachMarkContent.getAttribute(bc_coach_mark_constants_17.BC_COACH_MARK_DATA_ATTRIBUTE)) === stepActive; });
            var itemDom = document.getElementById(setStepNext.getAttribute(bc_coach_mark_constants_20.BC_COACH_MARK_DATA_CONTROLLER));
            if (setStepNext) {
                this.mySelf.removeAttribute(bc_coach_mark_constants_1.BC_COACH_MARK_POSITION);
                this.setValueTour(itemDom, setStepNext);
                this.setStepQuantity();
            }
        }
    };
    BcCoachMarkBehavior.prototype.restoreValueButton = function () {
        var button = this.mySelf.querySelector(".".concat(bc_coach_mark_constants_6.BC_COACH_MARK_FOOTER_FIRST_BUTTON));
        button.innerText = "".concat(bc_coach_mark_constants_23.BC_COACH_MARK_NEXT_TEXT);
        (0, helpers_1.replaceClass)(button, "".concat(bc_coach_mark_constants_14.BC_COACH_MARK_CLOSE), "".concat(bc_coach_mark_constants_12.BC_COACH_MARK_NEXT));
    };
    BcCoachMarkBehavior.prototype.setAccessibility = function () {
        var title = this.mySelf.querySelector(".".concat(bc_coach_mark_constants_2.BC_COACH_MARK_TITLE));
        var link = this.mySelf.querySelector(".".concat(bc_coach_mark_constants_1.BC_COACH_MARK_LINK, " ").concat(common_constants_1.BcCommonConstants.HREF_TAG));
        var buttonClose = this.mySelf.querySelector("".concat(common_constants_1.BcCommonConstants.SECTION_TAG, ".").concat(bc_coach_mark_constants_14.BC_COACH_MARK_CLOSE, " ").concat(common_constants_1.BcCommonConstants.BUTTON_TAG));
        if (title) {
            title.setAttribute(bc_coach_mark_constants_3.BC_COACH_MARK_ARIA_LABEL, bc_coach_mark_constants_2.BC_COACH_MARK_TITLE_ARIA + title.textContent + bc_coach_mark_constants_2.BC_COACH_MARK_TITLE_ARIA_TITLE);
        }
        if (link) {
            link.setAttribute(bc_coach_mark_constants_3.BC_COACH_MARK_ARIA_LABEL, link.textContent);
        }
        if (buttonClose) {
            buttonClose.setAttribute(bc_coach_mark_constants_3.BC_COACH_MARK_ARIA_LABEL, bc_coach_mark_constants_1.BC_COACH_MARK_CLOSE_TEXT);
        }
        (0, helpers_1.addFocusable)(this.mySelf, { tabindex: '0' });
        (0, helpers_1.addFocusable)(this.buttonUnderstand, { tabindex: '0' });
        (0, helpers_1.addFocusable)(this.buttonPrev, { tabindex: '0' });
        (0, helpers_1.addFocusable)(buttonClose, { tabindex: '0' });
        (0, helpers_1.addFocusable)(link, { tabindex: '0' });
    };
    BcCoachMarkBehavior.prototype.setPosition = function (coach, arrow, target) {
        var localization = new bc_location_builder_client_rect_utils_1.LocationBuilderClientRectUtils();
        var coachLocalizationBuilder = new bc_location_builder_1.BcLocationBuilder();
        var elementPosition = new bc_location_builder_position_1.BcLocationBuilderPosition();
        var viewportOffset = {
            height: window.innerHeight,
            width: window.innerWidth,
        };
        var targetOffset = elementPosition.getTargetOffset(target, localization);
        var coachOffset = elementPosition.getCoachOffset(coach, localization);
        var coachPosition = elementPosition.getCoachPosition(coachLocalizationBuilder, targetOffset, coachOffset, viewportOffset);
        if (coachOffset.width + coachPosition.x === viewportOffset.width) {
            coachPosition.x = coachPosition.x - bc_coach_mark_constants_7.BC_COACH_MARK_NUMBER_16;
        }
        else if (coachPosition.x === 0) {
            coachPosition.x = coachPosition.x + bc_coach_mark_constants_7.BC_COACH_MARK_NUMBER_16;
        }
        elementPosition.evaluateArrowPosition(coachLocalizationBuilder.position, arrow, targetOffset);
        this.setElementPosition(coachPosition);
        elementPosition.setElementPosition(coachPosition, this.coachMarkElement, coachLocalizationBuilder.position);
        this.resizeElement(elementPosition, target, localization, coach, coachLocalizationBuilder, arrow);
    };
    BcCoachMarkBehavior.prototype.resizeElement = function (elementPosition, target, localization, coach, coachLocalizationBuilder, arrow) {
        var coachMarkElement = this.mySelf;
        var viewportOffset = {
            height: window.innerHeight,
            width: window.innerWidth,
        };
        var targetOffsetResize;
        var coachOffsetResize;
        var coachPositionResize;
        window.addEventListener('resize', function (event) {
            targetOffsetResize = elementPosition.getTargetOffset(target, localization);
            coachOffsetResize = elementPosition.getCoachOffset(coach, localization);
            coachPositionResize = elementPosition.getCoachPosition(coachLocalizationBuilder, targetOffsetResize, coachOffsetResize, viewportOffset);
            elementPosition.evaluateArrowPosition(coachLocalizationBuilder.position, arrow, targetOffsetResize);
            if (coachOffsetResize.width + coachPositionResize.x === viewportOffset.width) {
                coachPositionResize.x = coachPositionResize.x - bc_coach_mark_constants_7.BC_COACH_MARK_NUMBER_16;
            }
            else if (coachPositionResize.x === 0) {
                coachPositionResize.x = coachPositionResize.x + bc_coach_mark_constants_7.BC_COACH_MARK_NUMBER_16;
            }
            coachMarkElement['style'].left = coachPositionResize.x + 'px';
            coachMarkElement['style'].top = coachPositionResize.y + 'px';
            coachMarkElement.scrollIntoView();
        });
        return { targetOffsetResize: targetOffsetResize, coachOffsetResize: coachOffsetResize, coachPositionResize: coachPositionResize };
    };
    BcCoachMarkBehavior.prototype.setElementPosition = function (coachPosition) {
        this.mySelf['style'].left = coachPosition.x + 'px';
        this.mySelf['style'].top = coachPosition.y + 'px';
        this.coachMarkElement.style.animation = bc_coach_mark_constants_4.BC_COACH_MARK_ANIMATION_IN;
        this.focusElement();
    };
    BcCoachMarkBehavior.prototype.setTargetBackground = function (target) {
        var backgroundColor = window.getComputedStyle(target).backgroundColor;
        var parent = target.parentElement;
        if (backgroundColor === 'rgba(0, 0, 0, 0)' || backgroundColor === '') {
            backgroundColor = window.getComputedStyle(parent).backgroundColor;
            while (backgroundColor === 'rgba(0, 0, 0, 0)') {
                parent = parent.parentElement;
                backgroundColor = window.getComputedStyle(parent).backgroundColor;
            }
        }
        target['style'].backgroundColor = backgroundColor;
    };
    BcCoachMarkBehavior.prototype.setInitTargetZIndex = function (target) {
        this.initParent = target.closest(".".concat(bc_coach_mark_constants_8.BC_COACH_MARK_TARGET));
        var parent = target.parentElement;
        var zIndex = window.getComputedStyle(parent).zIndex;
        parent['style'].zIndex = 'auto';
        this.hashMap.set(parent, zIndex);
        while (parent != this.initParent) {
            parent = parent.parentElement;
            zIndex = window.getComputedStyle(parent).zIndex;
            parent['style'].zIndex = 'auto';
            this.hashMap.set(parent, zIndex);
        }
    };
    BcCoachMarkBehavior.prototype.setTargetZIndexClose = function () {
        this.hashMap.forEach(function (values, keys) {
            keys['style'].zIndex = values;
        });
    };
    return BcCoachMarkBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcCoachMarkBehavior = BcCoachMarkBehavior;
